import { CloseIcon, AlertCircleSolidIcon } from '@bfe/moly-icons';
import cls from 'classnames';

import styles from './index.module.less';
import { useMemo, useRef, useEffect, useState } from 'react';

interface IProps {
  visible?: boolean;
  data: any[] | string;
  handleCloseClick?: () => void;
}

export const NoticeBar = ({ visible, data, handleCloseClick }: IProps) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTextWrapped, setIsTextWrapped] = useState(false);

  const isStrType = useMemo(() => {
    return typeof data === 'string';
  }, [data]);

  useEffect(() => {
    if (textRef.current) {
      // 单行文字时取消走马灯效果
      const isWrapped =
        textRef.current.scrollWidth > textRef.current.offsetWidth;
      setIsTextWrapped(isWrapped);
    }
  }, []);

  // visible 在 staking首页使用
  if (!visible || !data || !data?.length) return <></>;

  return (
    <div className={cls('flex items-center', styles.container)}>
      <AlertCircleSolidIcon className={cls(styles.alertCircle)} />
      <div
        className={cls(
          'whitespace-nowrap flex-1 overflow-hidden',
          styles.marquee
        )}
        ref={textRef}
      >
        <p className={cls(styles.text, isTextWrapped ? '' : styles.pause)}>
          {Array.isArray(data) &&
            data.map((text: any) => {
              return <span key={text}>{text}</span>;
            })}
          {isStrType && data}
        </p>
      </div>
      {handleCloseClick && (
        <CloseIcon
          className={cls('cursor-pointer', styles.closeBtn)}
          onClick={handleCloseClick}
        />
      )}
    </div>
  );
};
